/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as Auth_not_requiredRouteRouteImport } from './routes/_auth_not_required/route'
import { Route as Auth_requiredIndexRouteImport } from './routes/_auth_required/index'
import { Route as Auth_not_requiredSignupRouteImport } from './routes/_auth_not_required/signup'
import { Route as Auth_not_requiredSigninRouteImport } from './routes/_auth_not_required/signin'
import { Route as Auth_not_requiredConfirmRouteImport } from './routes/_auth_not_required/confirm'
import { Route as Auth_requiredSecuritiesReportChunksSecuritiesReportChunkIdRouteImport } from './routes/_auth_required/securities-report-chunks/$securitiesReportChunkId'

const Auth_not_requiredRouteRoute = Auth_not_requiredRouteRouteImport.update({
  id: '/_auth_not_required',
  getParentRoute: () => rootRouteImport,
} as any)
const Auth_requiredIndexRoute = Auth_requiredIndexRouteImport.update({
  id: '/_auth_required/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const Auth_not_requiredSignupRoute = Auth_not_requiredSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => Auth_not_requiredRouteRoute,
} as any)
const Auth_not_requiredSigninRoute = Auth_not_requiredSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => Auth_not_requiredRouteRoute,
} as any)
const Auth_not_requiredConfirmRoute = Auth_not_requiredConfirmRouteImport.update({
  id: '/confirm',
  path: '/confirm',
  getParentRoute: () => Auth_not_requiredRouteRoute,
} as any)
const Auth_requiredSecuritiesReportChunksSecuritiesReportChunkIdRoute = Auth_requiredSecuritiesReportChunksSecuritiesReportChunkIdRouteImport.update({
  id: '/_auth_required/securities-report-chunks/$securitiesReportChunkId',
  path: '/securities-report-chunks/$securitiesReportChunkId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/confirm': typeof Auth_not_requiredConfirmRoute
  '/signin': typeof Auth_not_requiredSigninRoute
  '/signup': typeof Auth_not_requiredSignupRoute
  '/': typeof Auth_requiredIndexRoute
  '/securities-report-chunks/$securitiesReportChunkId': typeof Auth_requiredSecuritiesReportChunksSecuritiesReportChunkIdRoute
}
export interface FileRoutesByTo {
  '/confirm': typeof Auth_not_requiredConfirmRoute
  '/signin': typeof Auth_not_requiredSigninRoute
  '/signup': typeof Auth_not_requiredSignupRoute
  '/': typeof Auth_requiredIndexRoute
  '/securities-report-chunks/$securitiesReportChunkId': typeof Auth_requiredSecuritiesReportChunksSecuritiesReportChunkIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth_not_required': typeof Auth_not_requiredRouteRouteWithChildren
  '/_auth_not_required/confirm': typeof Auth_not_requiredConfirmRoute
  '/_auth_not_required/signin': typeof Auth_not_requiredSigninRoute
  '/_auth_not_required/signup': typeof Auth_not_requiredSignupRoute
  '/_auth_required/': typeof Auth_requiredIndexRoute
  '/_auth_required/securities-report-chunks/$securitiesReportChunkId': typeof Auth_requiredSecuritiesReportChunksSecuritiesReportChunkIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/confirm' | '/signin' | '/signup' | '/' | '/securities-report-chunks/$securitiesReportChunkId'
  fileRoutesByTo: FileRoutesByTo
  to: '/confirm' | '/signin' | '/signup' | '/' | '/securities-report-chunks/$securitiesReportChunkId'
  id:
    | '__root__'
    | '/_auth_not_required'
    | '/_auth_not_required/confirm'
    | '/_auth_not_required/signin'
    | '/_auth_not_required/signup'
    | '/_auth_required/'
    | '/_auth_required/securities-report-chunks/$securitiesReportChunkId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  Auth_not_requiredRouteRoute: typeof Auth_not_requiredRouteRouteWithChildren
  Auth_requiredIndexRoute: typeof Auth_requiredIndexRoute
  Auth_requiredSecuritiesReportChunksSecuritiesReportChunkIdRoute: typeof Auth_requiredSecuritiesReportChunksSecuritiesReportChunkIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth_not_required': {
      id: '/_auth_not_required'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof Auth_not_requiredRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth_required/': {
      id: '/_auth_required/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof Auth_requiredIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth_not_required/signup': {
      id: '/_auth_not_required/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof Auth_not_requiredSignupRouteImport
      parentRoute: typeof Auth_not_requiredRouteRoute
    }
    '/_auth_not_required/signin': {
      id: '/_auth_not_required/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof Auth_not_requiredSigninRouteImport
      parentRoute: typeof Auth_not_requiredRouteRoute
    }
    '/_auth_not_required/confirm': {
      id: '/_auth_not_required/confirm'
      path: '/confirm'
      fullPath: '/confirm'
      preLoaderRoute: typeof Auth_not_requiredConfirmRouteImport
      parentRoute: typeof Auth_not_requiredRouteRoute
    }
    '/_auth_required/securities-report-chunks/$securitiesReportChunkId': {
      id: '/_auth_required/securities-report-chunks/$securitiesReportChunkId'
      path: '/securities-report-chunks/$securitiesReportChunkId'
      fullPath: '/securities-report-chunks/$securitiesReportChunkId'
      preLoaderRoute: typeof Auth_requiredSecuritiesReportChunksSecuritiesReportChunkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface Auth_not_requiredRouteRouteChildren {
  Auth_not_requiredConfirmRoute: typeof Auth_not_requiredConfirmRoute
  Auth_not_requiredSigninRoute: typeof Auth_not_requiredSigninRoute
  Auth_not_requiredSignupRoute: typeof Auth_not_requiredSignupRoute
}

const Auth_not_requiredRouteRouteChildren: Auth_not_requiredRouteRouteChildren = {
  Auth_not_requiredConfirmRoute: Auth_not_requiredConfirmRoute,
  Auth_not_requiredSigninRoute: Auth_not_requiredSigninRoute,
  Auth_not_requiredSignupRoute: Auth_not_requiredSignupRoute,
}

const Auth_not_requiredRouteRouteWithChildren = Auth_not_requiredRouteRoute._addFileChildren(Auth_not_requiredRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  Auth_not_requiredRouteRoute: Auth_not_requiredRouteRouteWithChildren,
  Auth_requiredIndexRoute: Auth_requiredIndexRoute,
  Auth_requiredSecuritiesReportChunksSecuritiesReportChunkIdRoute: Auth_requiredSecuritiesReportChunksSecuritiesReportChunkIdRoute,
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)._addFileTypes<FileRouteTypes>()
